<!-- ----------------------------------------------------------------------- -->
<!--                               Form Start                                -->
<!-- ----------------------------------------------------------------------- -->

<section class="row">
    <div class="form col-8 col-md-7 col-lg-6 mx-auto mt-5">
        <div class="fom-header row">
            <div class="form-header__title col-12 mx-auto">
                <div class="form-header-title__back">
                    <a  class="cursor-pointer" (click)="redirect();" role="button" >
                        <i class="fas fa-chevron-left"></i>
                        
                        <span class="sr-only">Previous</span>
                      </a>
                </div>
            </div>
            
        <div class="col-12 form-header-img">
            <figure class="form-header-img__container"><img class="img-fluid" src="{{organization?.logo_url}}" default="web-assets/images/group-3.png"></figure>
        </div>
        <div class="form-header-title col-12">
            {{organization?.name}}
        </div>
            <div class="form-header-subtitle  col-12">
                <p class="form-header-subtitle__text">
                    {{organization?.description}}
                   
                </p>
            </div>
        </div>

        <div class="col-12" *ngIf="isShowSelectBtn">
            <div class="form-body__submit ">
                <a  class="form-body__sumbit-btn" (click)="RedirectToMinMax()">NEXT</a>
            </div>
        </div>

    </div>
</section>

